module.exports = __webpack_public_path__ + "static/media/hepsiburada.6373f02b.png";